import { useQuery } from 'react-query';
import { getAdaptedFictionPreviewDetail } from '../../services/sceneService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetAdaptedFictionPreviewDetail({
  adaptedFictionPreviewId,
  castRelationshipId,
  enabled = true
}: {
  adaptedFictionPreviewId: string;
  castRelationshipId: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: SCENE_QUERY_KEYS.adaptedFictionPreviewDetail(
      adaptedFictionPreviewId,
      castRelationshipId
    ),
    queryFn: () => getAdaptedFictionPreviewDetail({ adaptedFictionPreviewId, castRelationshipId }),
    enabled: enabled
  });
}
